import React from 'react';
import { Box, IconButton, Tooltip, Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useSnackbar } from 'notistack';

// Pretty JSON with a copy button. If `title` is given, render inside an Accordion.
const JsonViewer = ({ data, title, defaultExpanded = false }) => {
  const { enqueueSnackbar } = useSnackbar();
  const text = JSON.stringify(data, null, 2);

  const copy = async (e) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(text);
      enqueueSnackbar('Copied to clipboard', { variant: 'success' });
    } catch {
      enqueueSnackbar('Copy failed', { variant: 'error' });
    }
  };

  const pre = (
    <Box sx={{ position: 'relative' }}>
      <Tooltip title="Copy">
        <IconButton size="small" onClick={copy} sx={{ position: 'absolute', top: 4, right: 4, color: '#a0aec0' }}>
          <ContentCopyIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Box
        component="pre"
        sx={{
          m: 0,
          p: 2,
          bgcolor: '#1a202c',
          color: '#68d391',
          borderRadius: 2,
          overflow: 'auto',
          fontSize: 12.5,
          maxHeight: 420,
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word'
        }}
      >
        {text}
      </Box>
    </Box>
  );

  if (!title) return pre;

  return (
    <Accordion defaultExpanded={defaultExpanded} disableGutters>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="subtitle2">{title}</Typography>
      </AccordionSummary>
      <AccordionDetails>{pre}</AccordionDetails>
    </Accordion>
  );
};

export default JsonViewer;
